import { render, staticRenderFns } from "./Persent.vue?vue&type=template&id=d3c13514"
import script from "./Persent.vue?vue&type=script&lang=js"
export * from "./Persent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports